import { useSelector } from 'react-redux';
import useModulePrivileges from '@wix/da-gruser-shared/pkg/hooks/useModulePrivileges';
import { getCurrentUserHasCore } from '../../publicSession/selectors';
export const useShowCoreUpsell = (moduleId)=>{
    const hasCore = useSelector(getCurrentUserHasCore);
    const modulePrivs = useModulePrivileges(moduleId);
    const isOwner = !!(modulePrivs === null || modulePrivs === void 0 ? void 0 : modulePrivs.edit);
    return !hasCore && isOwner;
};
export default useShowCoreUpsell;

//# sourceMappingURL=useShowCoreUpsell.js.map